import { render, staticRenderFns } from "./V2CollectionList.vue?vue&type=template&id=14f0245c&scoped=true&"
import script from "./V2CollectionList.vue?vue&type=script&lang=js&"
export * from "./V2CollectionList.vue?vue&type=script&lang=js&"
import style0 from "./V2CollectionList.vue?vue&type=style&index=0&id=14f0245c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f0245c",
  null
  
)

export default component.exports